var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#37427A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 5C13.3467 5 14.84 5.37333 15.88 6.12C16.9333 6.85333 17.46 7.95333 17.46 9.42C17.46 10.22 17.3133 10.9067 17.02 11.48C16.74 12.04 16.3267 12.5 15.78 12.86C15.2467 13.2067 14.5933 13.46 13.82 13.62C13.0467 13.78 12.1733 13.86 11.2 13.86H9.66V19H7.72V5.34C8.26667 5.20667 8.87333 5.12 9.54 5.08C10.22 5.02667 10.84 5 11.4 5ZM11.56 6.7C10.7333 6.7 10.1 6.72 9.66 6.76V12.2H11.12C11.7867 12.2 12.3867 12.16 12.92 12.08C13.4533 11.9867 13.9 11.84 14.26 11.64C14.6333 11.4267 14.92 11.14 15.12 10.78C15.32 10.42 15.42 9.96 15.42 9.4C15.42 8.86667 15.3133 8.42667 15.1 8.08C14.9 7.73333 14.62 7.46 14.26 7.26C13.9133 7.04667 13.5067 6.9 13.04 6.82C12.5733 6.74 12.08 6.7 11.56 6.7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPFrame);
export default __webpack_public_path__ + "static/media/p_frame.b9c3ea44.svg";
export { ForwardRef as ReactComponent };